import {
  SET_CHANGE_LOGS,
} from './mutationTypes';

import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';


export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_CHANGE_LOGS](state, changeLogs) {
    state.changeLogs = changeLogs;
  }
};